import { useState, useEffect, useRef, useContext } from 'react'
import styled from 'styled-components'
import { animated, useSpring, config } from '@react-spring/web'
import { device } from '../../breakpoints'
import { YearContext } from 'contexts'

const Cover = () => {
  const year = useContext(YearContext)
  const observer = useRef<IntersectionObserver | null>(null)
  const [containerRef, setContainerRef] = useState<HTMLDivElement | null>(null)
  const [ImageContaineRef, setImageContainerRef] =
    useState<HTMLDivElement | null>(null)
  const [prevRatio, setPrevRatio] = useState(0)

  const spring = useSpring({
    value: prevRatio,
    config: config.stiff,
  })

  const handleScroll = () => {
    if (!containerRef || !ImageContaineRef) return
    const pct = Math.max(
      0,
      Math.min(
        1,
        -containerRef.getBoundingClientRect().top / (window.innerHeight - 120)
      )
    )

    // ImageContaineRef.style.setProperty(
    //   'background-position',
    //   `50% calc(50% + ${window.scrollY * 0.75}px)`
    // )

    ImageContaineRef.style.setProperty('transform', `scale(${1 + pct * 0.2})`)

    ImageContaineRef.style.setProperty('opacity', `${1 - pct * 0.5 - 0.55}`)
  }

  useEffect(() => {
    if (!containerRef || !ImageContaineRef) return

    const handleIntersection = (entries: IntersectionObserverEntry[]) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          window.addEventListener('scroll', handleScroll)
        } else {
          window.removeEventListener('scroll', handleScroll)
        }
      })
    }

    let options = {
      rootMargin: '0px',
      threshold: 0,
    }

    observer.current = new IntersectionObserver(handleIntersection, options)
    observer.current.observe(containerRef as Element)
  }, [containerRef, ImageContaineRef])

  return (
    <Container ref={setContainerRef}>
      <ImageContainer ref={setImageContainerRef}></ImageContainer>
      <TextContainer>
        <MainLogos>
          <Logo
            src={require('../../images/logos/bilan-inverted.svg').default}
          />
          <PartnerLogo
            src={require('../../images/logos/svit_romandie_logo.png')}
          />
        </MainLogos>
        <div>Prix de l'immobilier romand</div>
        <span>{year}</span>
        {/* <TextFragment1>Prix</TextFragment1>
        <TextFragment1b>de</TextFragment1b>
        <TextFragment2>l'immobilier</TextFragment2>
        <TextFragment3>romand</TextFragment3>
        <TextFragment4>2023</TextFragment4> */}
      </TextContainer>
      {/* <Actions>
        <Button>Les projets <BsArrowDownShort /></Button>
      </Actions> */}

      <LogosLayer>
        <SponsorLogo
          src={require('../../images/logos/resized/bernard_nicod_logo.png')}
        />
        <SponsorLogo
          src={require('../../images/logos/resized/magenta_logo.png')}
        />
        <SponsorLogo
          src={require('../../images/logos/resized/sanitas_logo.png')}
        />
        <SponsorLogo
          src={require('../../images/logos/resized/schindler_logo.png')}
        />
        <SponsorLogo
          src={require('../../images/logos/resized/swiss_caution_logo.png')}
        />
        <SponsorLogo
          src={require('../../images/logos/resized/swissroc_logo.png')}
        />
      </LogosLayer>
    </Container>
  )
}

const Container = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #222222;
  overflow: hidden;
  // border-radius: 16px;
  flex-direction: column;

  &:after {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    height: 100%;
    width: 100%;
    // Gradient background
    background: #22222222;
  }
`

const MainLogos = styled.div`
  display: flex;
  align-items: center;
  z-index: 1;
  margin-bottom: 5rem;
`

const LogosLayer = styled.div`
  text-align: center;
  position: absolute;
  bottom: 30px;
  line-height: 0;
  z-index: 1;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    bottom: auto;
    position: relative;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    position: absolute;
    bottom: 30px;
  }
`

const Year = styled.span`
  background-color: ${(props) => props.theme.colorMain};
`

const SponsorLogo = styled.img`
  height: 80px;
  margin: 0 10px;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    height: 50px;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    height: 80px;
  }
`

const ImageContainer = styled(animated.div)`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  width: 100%;
  height: 100%;
  background-image: url(${require('./cover.jpg')});
  background-size: cover;
  background-position: 50% 50%;
  opacity: 0.45;
  transform: translate3d(0, 0, 0);
`

const TextContainer = styled.div`
  position: relative;
  z-index: 1;
  color: white;
  display: grid;
  grid-template-rows: repeat(12, 1fr);
  grid-template-columns: repeat(12, 1fr);

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: clamp(5rem, 7vw, 10rem);
  font-family: var(--font-sans-serif);
  font-weight: 400;
  letter-spacing: -0.05em;
  text-align: center;

  span {
    font-size: clamp(3rem, 3vw, 10rem);
    // border: 3px solid #ffffff;
    background: #ffffff22;
    backdrop-filter: blur(2px);
    border-radius: 80px;
    padding: 0.25em 0.5em;
    opacity: 0.95;
    margin-top: 4rem;
  }

  height: 100%;
  width: 100%;
  // max-width: 900px;
  // font-size: 8vw;
  font-family: var(--font-sans-serif);
  font-weight: 400;
  letter-spacing: -0.05em;
  line-height: 1;
  // text-align: center;
  padding: 0 20px;
  box-sizing: border-box;
`

const Actions = styled.div`
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
`

const TextFragment = styled.div`
  font-size: 10vw;
  font-family: var(--font-sans-serif);
  font-weight: 400;
  letter-spacing: -0.05em;
`

const TextFragment1 = styled(TextFragment)`
  grid-row: 3 / span 6;
  grid-column: 1 / span 6;
`

const TextFragment1b = styled(TextFragment)`
  grid-row: 3 / span 12;
  grid-column: 2 / span 12;
  text-align: right;
`

const Logo = styled.img`
  width: 100px;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    width: 60px;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    width: 100px;
  }
`

const PartnerLogo = styled(Logo)`
  width: 100px;
  margin-left: 20px;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    width: 70px;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    width: 100px;
  }
`

const TextFragment2 = styled(TextFragment)`
  grid-row: 5 / span 6;
  grid-column: 1 / span 12;
  text-align: left;
  padding-right: 20px;
`

const TextFragment3 = styled(TextFragment)`
  grid-row: 7 / 12;
  grid-column: 1 / span 12;
  text-align: left;
  padding-right: 20px;
`

const TextFragment4 = styled(TextFragment)`
  grid-row: 9 / span 6;
  grid-column: 6 / span 12;
  text-align: right;
`

export default Cover
